import module from './module/index';

export default {
  module
}



// WEBPACK FOOTER //
// ./src/locales/no/component/index.js